/**
 * Canonical centralized contact information for Team Alpental Snoqualmie (TAS).
 * Used across PaymentConfirmation, Footer, Contact, and communications.
 */
export const SUPPORT_PHONE = '425.985.6875';
export const SUPPORT_PHONE_TEL = 'tel:425.985.6875';
export const SUPPORT_EMAIL = 'info@tas.ski';
export const SUPPORT_EMAIL_MAILTO = 'mailto:info@tas.ski';
export const CLUB_ADDRESS = 'Seattle, Washington';

export const CONTACT_INFO = {
    phone: SUPPORT_PHONE,
    phoneTel: SUPPORT_PHONE_TEL,
    email: SUPPORT_EMAIL,
    emailMailto: SUPPORT_EMAIL_MAILTO,
    address: CLUB_ADDRESS
};
